<template>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <p class="title text-xs-center">Add New Operator</p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="Operator Name"
            required
          ></v-text-field>
          
           <v-autocomplete
            v-model="country"
            :items="countryNameList"
            :rules="countryRules"
            label="Country Name"
            @input="updateCountryInfo"
            persistent-hint
            required
          ></v-autocomplete>

          <v-text-field
            v-model="code"
            label="Country Code"
            :value="code"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="iso"
            label="ISO Code"
            disabled
          ></v-text-field>
    
          <v-checkbox
            v-model="status"
            :rules="[v => !!v || 'Please check the box to make operator active.']"
            label="Do you want to make it active?"
            required
          ></v-checkbox>
          <div class="text-xs-center">
            <v-btn @click="clear">clear</v-btn>
            <v-btn
              color="primary"
              :disabled="!valid"
              @click="submit"
            >
              submit
            </v-btn>
          </div>
        </v-form>
      </v-flex>
    </v-layout>
</template>

<script>
  import axios from 'axios'

  import { SERVER_URL } from './../../constant.js'

  export default {
    data: () => ({
      valid: false,
      name: '',
      nameRules: [
        v => !!v || 'Name is required'
      ],
      country: '',
      countryRules: [
        v => !!v || 'Country is required'
      ],
      code: '',
      iso: '',
      status: false,
      countries: [],
      countryNameList: []
    }),
    created () {
      axios.get(`${SERVER_URL}/country/all`).then(res => {
        res.data.forEach(val => {
          this.countries.push({iso: val.iso, name: val.name, code: val.code})
          this.countryNameList.push(val.name)
        })
      })

    },
    methods: {
      
      submit () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          axios.post(`${SERVER_URL}/operator/add`, {
            name: this.name,
            countryName: this.country,
            countryCode: this.code,
            countryISO: this.iso,
            status: this.status
          }).then(res => {
            var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Operator Added Successfully'})
            document.dispatchEvent(showSnackbarEvent)
            this.$refs.form.reset()
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      },
      updateCountryInfo() {
        if(this.country) var ctr = this.countries.find(val => val.name === this.country)
        if(ctr) this.code = ctr.code
        if(ctr) this.iso = ctr.iso
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/operator/AddOperator.vue